var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletebtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(-1071 -655)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8255",
    "data-name": "Rectangle 8255",
    width: 42,
    height: 42,
    rx: 21,
    transform: "translate(1071 655)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(1081 665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4694",
    "data-name": "Path 4694",
    d: "M17.628,7a.909.909,0,0,0-.909.909V18.076a1.744,1.744,0,0,1-1.826,1.644H7.643a1.744,1.744,0,0,1-1.826-1.644V7.909A.909.909,0,1,0,4,7.909V18.076a3.56,3.56,0,0,0,3.643,3.461h7.25a3.56,3.56,0,0,0,3.643-3.461V7.909A.909.909,0,0,0,17.628,7Z",
    transform: "translate(-0.091 -0.549)",
    fill: "#080808",
    stroke: "#080808",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4695",
    "data-name": "Path 4695",
    d: "M18.445,3.726H14.811V1.909A.909.909,0,0,0,13.9,1H8.451a.909.909,0,0,0-.909.909V3.726H3.909a.909.909,0,1,0,0,1.817H18.445a.909.909,0,0,0,0-1.817Zm-9.086,0V2.817h3.634v.909Z",
    fill: "#080808",
    stroke: "#080808",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4696",
    "data-name": "Path 4696",
    d: "M10.817,16.268V9.909A.909.909,0,1,0,9,9.909v6.36a.909.909,0,1,0,1.817,0Z",
    transform: "translate(-0.549 -0.732)",
    fill: "#080808",
    stroke: "#080808",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4697",
    "data-name": "Path 4697",
    d: "M14.817,16.268V9.909a.909.909,0,1,0-1.817,0v6.36a.909.909,0,1,0,1.817,0Z",
    transform: "translate(-0.914 -0.732)",
    fill: "#080808",
    stroke: "#080808",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletebtn);
export default __webpack_public_path__ + "static/media/deletebtn.74cf32899e5d0d03f587c746f91c5645.svg";
export { ForwardRef as ReactComponent };